module.exports = __webpack_public_path__ + "img/couponStyle-1.afcdced1.jpg";